import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=1b92b11b&scoped=true&"
import script from "./permissions.vue?vue&type=script&lang=js&"
export * from "./permissions.vue?vue&type=script&lang=js&"
import style0 from "./permissions.vue?vue&type=style&index=0&id=1b92b11b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b92b11b",
  null
  
)

component.options.__file = "permissions.vue"
export default component.exports